(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (() => {
    const MOVE_TOLERANCE = 10;

    const setupBannerLinks = (root = document) => {
      root.querySelectorAll('slideshow-slide').forEach((slide) => {
        if (slide.dataset.maximeBannerLinkReady === 'true') return;

        const marker = slide.querySelector('.maxime-banner-link-marker');
        if (!marker) return;

        const url = marker.dataset.bannerLink;
        if (!url) return;

        slide.dataset.maximeBannerLinkReady = 'true';
        slide.classList.add('maxime-banner-clickable');

        let startX = 0;
        let startY = 0;
        let moved = false;

        slide.addEventListener('pointerdown', (event) => {
          startX = event.clientX;
          startY = event.clientY;
          moved = false;
        });

        slide.addEventListener('pointermove', (event) => {
          if (
            Math.abs(event.clientX - startX) > MOVE_TOLERANCE ||
            Math.abs(event.clientY - startY) > MOVE_TOLERANCE
          ) {
            moved = true;
          }
        });

        slide.addEventListener('click', (event) => {
          if (moved) return;

          if (
            event.target.closest(
              'a, button, input, select, textarea, summary, [role="button"], [data-no-banner-link]'
            )
          ) {
            return;
          }

          window.location.href = url;
        });
      });
    };

    const initialize = () => {
      setupBannerLinks(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      setupBannerLinks(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
